import React from 'react'
import "../../CSS/Blog/Tempweb.css"
import FooTer from "../footer"
import TempZip from "../../Projects/Blog/Temperature Calculate.zip"

export default function TemperatureWebsite() {
    return (
        <>
            <h1 id="start">Creating A Temperature Calculate Website!</h1>
            <hr />
            <p className="hd">In This Video I Created A Responsive Temperature Calculate Website</p>
            <div className="phishing-yt">
                <iframe id="yt" src="https://www.youtube.com/embed/9GZuq0iKtiY" title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
            </div>
            <div className="yt-visit">
                <p id="sub">
                    If You Guys Injoy My Video So Visit My Youtube Channel:
                </p>
                <a id="cd" rel="noreferrer" href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg" target="_blank"><button>Code Arindam</button></a>
            </div>
            <p className="ans">
                In This Video Using: <br />
                <br />
                1) HTML<br />
                2) CSS<br />
                3) JAVASCRIPT (JS)<br />
            </p>
            <p className="q">
                This Website Help Us By?
            </p>
            <p className="ans">
                This website would be help us like we can be calculate temperature on celcius To Fahrenheit Or Fahrenheit to celcius.
            </p>
            <p className="q">
                In This Video We Using...
            </p>
            <p className="ans">
                HTML,CSS,JS One Of the powerfull website creating languages. so from how you guys should be create this responsive website with Media Queres for phone screen just watch the full video and injoy it.
            </p>
            <p className="q">
                :: DOWNLOAD THE FULL ZIP FILE OF Temperature Calculate Site ::
            </p>
            <div className="zip-downloader">
                <button id="zip"><a href={TempZip}>DOWNLOAD</a></button>
            </div>
            <p className="last">
                So Hope You Guys Injoy This Video And So Be Carefull And Stay Helthy And Have A Great Day...
            </p>
            <FooTer/>
        </>
    )
}
